import { ClientBranding } from '@brands/services/identity/types/UserProfile';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ClientBrandingState {
  clientBranding: ClientBranding | null;
}

const initialState: ClientBrandingState = {
  clientBranding: null,
};

export const clientBrandingSlice = createSlice({
  name: 'clientBranding',
  initialState,
  reducers: {
    setClientBranding: (state, action: PayloadAction<{ clientBranding: ClientBranding | null }>) => {
      return { clientBranding: action.payload.clientBranding };
    },
  },
});

export const { setClientBranding } = clientBrandingSlice.actions;

export default clientBrandingSlice.reducer;
